import yup from 'src/libraries/validator.library';

export const DroneAreasShape = {
  SensitiveCityLocation: yup.string().required(),
};

export const DroneAreasSchema = yup
  .object()
  .shape({
    droneAreasId: yup.number(),
    ...DroneAreasShape,
  })
  .defined();

export const DroneAreasListSchema = yup
  .object({
    droneAreas: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                droneAreasId: yup.number(),
                ...DroneAreasShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const DroneAreasFormSchema = yup
  .object()
  .shape({
    droneAreasId: yup.number(),
    SensitiveCityLocation: yup.string().required(),
  })
  .defined();

export const DroneAreasResponsePayloadSchema = yup
  .object({
    droneAreas: yup
      .object({
        droneAreasId: yup.number(),
        SensitiveCityLocation: yup.string(),
      })
      .defined(),
  })
  .defined();

export type IDroneAreas = yup.InferType<typeof DroneAreasSchema>;
export type IDroneAreasList = yup.InferType<typeof DroneAreasListSchema>;
export type IDroneAreasForm = yup.InferType<typeof DroneAreasFormSchema>;
